<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
    :show="showDropDown"
  >
    <template #toggler>
      <!-- @click.native="previewChannelMessages()" -->
      <CHeaderNavLink style="position: relative">
        <CIcon name="cil-envelope-open" />
        <span class="notify-count">{{ notifyCount }}</span>
      </CHeaderNavLink>
    </template>
    <template>
      <CDropdownHeader tag="div" class="text-center" color="light">
        <strong>You have {{ notifyCount }} messages</strong>
      </CDropdownHeader>
      <CDropdownItem>
        <div class="message" style="min-width: 485px" v-if="showDropDownLoader">
          <semipolar-spinner
            :animation-duration="2000"
            :size="100"
            color="blue"
          ></semipolar-spinner>
        </div>
      </CDropdownItem>
      <template v-if="!showDropDownLoader">
        <div style="max-height: 400px; overflow-y: scroll">
          <CDropdownItem v-for="item of items" :key="item.last_message.id">
            <div class="message" style="min-width: 485px">
              <div class="py-3 mfe-3 float-left">
                <div class="c-avatar">
                  <img class="c-avatar-img" :src="getImage(image_small)" /><span
                    class="c-avatar-status bg-warning"
                  ></span>
                </div>
              </div>
              <div>
                <small class="text-muted">{{
                  item.last_message.record_name
                }}</small
                ><small class="text-muted float-right mt-1">
                  {{ item.last_message.date }}
                </small>
              </div>
              <div class="text-truncate font-weight-bold">
                <span class="text-danger">!</span>
                {{ item.last_message.subject }}
              </div>
              <div
                class="small text-muted text-truncate"
                v-html="item.last_message.body"
              ></div>
            </div>
          </CDropdownItem>
        </div>
      </template>
      <!-- to="/Allmessages" -->
      <CDropdownItem v-if="!showDropDownLoader">
        <a @click="viewAllMessages()"><strong>View all messages</strong></a>
      </CDropdownItem>
    </template>
  </CDropdown>
</template>

<script>
import store from "../store";
import { SemipolarSpinner } from "epic-spinners";

export default {
  name: "TheHeaderDropdownBell",
  components: { SemipolarSpinner },
  data() {
    return {
      itemsCount: 42,
      notifyCount: 0,
      channelIds: [],
      showDropDown: false,
      showDropDownLoader: false,
      image_small: "",
      items: [],
      pollTimeStampData: null,
      pollTimeStampTimerRef: null,
      lastId: 1,
      dummyResponsePayload: {
        jsonrpc: "2.0",
        id: 815981863,
        result: [
          {
            message: {
              module_icon: "/mail/static/description/icon.png",
              channel_ids: [3],
              author_id: [3, "Administrator"],
              body: "<p>ddd</p>",
              date: "2021-06-03 06:47:27",
              customer_email_status: "sent",
              subtype_id: [1, "Discussions"],
              subject: false,
              email_from: '"Administrator" <fernando@apachedigital.io>',
              model: "mail.channel",
              partner_ids: [],
              subtype_description: false,
              customer_email_data: [],
              res_id: 3,
              starred_partner_ids: [],
              is_notification: false,
              is_discussion: true,
              attachment_ids: [],
              tracking_value_ids: [],
              is_note: false,
              needaction_partner_ids: [],
              message_type: "comment",
              record_name: "Informaci\u00f3n de Brand Whisper",
              moderation_status: "accepted",
              id: 52,
            },
            id: 68,
            channel: ["staging", "mail.channel", 3],
          },
        ],
      },
    };
  },
  mounted() {
    this.loadChannels();
  },
  methods: {
    async loadChannels() {
      this.channelIds = [];
      await store.dispatch("getUserChannels").then((data) => {
        let userChannelData = store.getters.get_N_UserChannels.data;
        console.log("userChannelData", userChannelData);
        if (userChannelData.records) {
          userChannelData = userChannelData.records;
          // console.log("info-", userChannelData);
          const length = userChannelData.length;
          this.notifyCount =
            userChannelData[length - 1]["message_unread_counter"] +
            (this.notifyCount - 0);
          this.channelIds.push(userChannelData[length - 1].id);
          this.image_small = userChannelData[length - 1].image_small;
          this.previewChannelMessages();
        }
      });
    },
    async previewChannelMessages() {
      this.items = [];
      this.showDropDownLoader = true;
      await store
        .dispatch("get_N_PreviewMessages", this.channelIds)
        .then((data) => {
          let previewData = store.getters.get_N_PreviewMessages;
          this.pushPreviewMessages(previewData.data);
          this.startPollTimeStamp();
        });
    },
    getImage(image) {
      return `data:image/png;base64,${image}`;
    },

    getKey() {
      return new Date().getTime();
    },

    guid() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return (
        s4() +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        s4() +
        s4()
      );
    },

    // ANCHOR Start Poll Timer Methods
    async startPoll() {
      await store
        .dispatch("get_N_ChannelPollMessages", {
          lastId: this.lastId,
        })
        .then((data) => {
          let response = store.getters.get_N_ChannelPollMessages.data;
          const rand = _.random(6, 8);
          // Check if data exists on response
          if (response && response.result && response.result.length > 0) {
            const length = response.result.length;
            const id = response.result[length - 1].id;
            this.lastId = id;
            let newDataToPushed = [];
            response.result.forEach((element) => {
              if (element.message.record_name) {
                newDataToPushed = [
                  ...newDataToPushed,
                  {
                    last_message: {
                      record_name: element.message.email_from,
                      date: element.message.date,
                      // date: new Date(),
                      subject: element.message.record_name,
                      body: element.message.body,
                      id: element.id ? element.id : this.getKey(),
                    },
                  },
                ];
              }
            });
            if (newDataToPushed.length) {
              this.notifyCount += response.result.length - 0;
              // console.log(
              //   "info",
              //   "newDataToPushed",
              //   newDataToPushed,
              //   this.notifyCount
              // );
              this.pushPreviewMessages(newDataToPushed);
            }
          }

          this.pollTimeStampData = new Date().getTime();
          // console.log(
          //   `info-${this.pollTimeStampData}`,
          //   "pollTimeStampTimer",
          //   response,
          //   response.id,
          //   rand
          // );
        });
    },
    startPollTimeStamp() {
      if (this.pollTimeStampTimerRef) {
        this.clearpollTimer();
      }
      this.pollTimeStampTimerRef = setTimeout(() => {
        this.startPoll();
      }, 1000);
    },
    clearpollTimer() {
      clearTimeout(this.pollTimeStampTimerRef);
    },
    //-------------------- Poll Timer ends-----------
    pushPreviewMessages(messages = []) {
      console.log("info-", "inc", messages);
      this.showDropDownLoader = true;
      let extDataArray = this.items;
      var ts = new Date().getTime();
      messages.forEach((nItem) => {
        let payload = {
          ...nItem,
          rid: this.guid(),
        };
        extDataArray.splice(0, 0, payload);
      });
      if (extDataArray.length > 10) {
        extDataArray = extDataArray.splice(0, 10);
      }
      extDataArray.map(
        (item, i) => (extDataArray[i].rid = new Date().getTime())
      );
      console.log("info-", "flt", extDataArray);
      this.items = extDataArray;
      this.showDropDownLoader = false;
    },
    viewAllMessages() {
      this.notifyCount = 0;
      this.$router.push({
        name: "Allmessages",
      });
    },
  },
  beforeDestroy() {
    this.clearpollTimer();
  },
  watch: {
    pollTimeStampData(n, o) {
      this.startPollTimeStamp();
    },

    //   userChannelsData(n, p) {
    //     console.log("info", "props", n, p);
    //   },
  },
};
</script>


<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
.notify-count {
  color: #fff;
  padding: 2px 7px;
  border-radius: 100%;
  font-weight: 600;
  font-size: 10px;
  position: absolute;
  top: -10px;
  right: -1px;
  background: linear-gradient(to right, #83c3e6, #008ad5);
}
</style>